import type { IconData } from '@stacksjs/iconify-core'

export const arrowCursor1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M11.526 38.338c.82 2.051 3.174 2.842 5.06 1.692a77 77 0 0 0 7.452-5.175l5.921 7.743c1.556 2.035 4.234 2.79 6.325 1.31c1.181-.835 2.583-1.975 4.116-3.508s2.673-2.935 3.509-4.116c1.48-2.092.725-4.769-1.31-6.325l-7.744-5.922a77 77 0 0 0 5.176-7.45c1.15-1.887.359-4.242-1.693-5.06c-5.05-2.016-15.322-5.59-30.817-8.542c-2.697-.514-5.05 1.84-4.536 4.535c2.952 15.495 6.526 25.768 8.541 30.818\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowCursor1
